import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    booking: [],
    loading: false,
    error: null,
  };
const bookingSlice = createSlice({
    name: "booking",
    initialState,
    reducers: {
        bookingRequest(state) {
        state.loading = true;
        state.error = null;
      },
      bookingSuccess(state, action) {
        state.loading = false;
        state.booking = action.payload;
      },
      bookingAddSuccess(state, action) {
        state.loading = false;
        state.booking.push(action.payload);
      },
      bookingEditSuccess(state, action) {
        state.loading = false;
        state.booking = state.booking.map((booking: { id: any; }) =>
          booking.id === action.payload.id ? action.payload : booking
        );
      },
      bookingDeleteSuccess(state, action) {
        state.loading = false;
        state.booking = state.booking.filter((booking: { id: any; }) => booking.id !== action.payload);
      },
      bookingError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      getBookingByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getBookingByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  // Store the user fetched by ID in `user`
      },
      getBookingByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      paymentRequest(state) {
        state.loading = true;
        state.error = null;
      },
      paymentSuccess(state, action) {
        state.loading = false;
        state.booking = action.payload;  // Store the user fetched by ID in `user`
      },
      paymentError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      paymentAddSuccess(state, action) {
        state.loading = false;
        state.booking.push(action.payload);  // Store the user fetched by ID in `user`
      },
      paymentEditSuccess(state, action) { 
        state.loading = false;
        state.booking = state.booking.map((booking: { id: any; }) =>
          booking.id === action.payload.id ? action.payload : booking
        );
      },
      paymentDeleteSuccess(state, action) {
        state.loading = false;
        state.booking = state.booking.filter((booking: { id: any; }) => booking.id !== action.payload);
      },
      
    },
  });

  export const {
      bookingRequest,
      bookingSuccess,
      bookingAddSuccess,
      bookingEditSuccess,
      bookingDeleteSuccess,
      bookingError,
      getBookingByIdRequest,
      getBookingByIdSuccess,
      getBookingByIdError,
      paymentRequest,
      paymentSuccess,
      paymentError,
      paymentAddSuccess,
      paymentEditSuccess,
      paymentDeleteSuccess,
  } = bookingSlice.actions;

export default bookingSlice.reducer;
  